<template>
	<div>
		<!-- <div class="followup-conversion-title">Tracking Statistic</div> -->
		<ul class="nav nav-tabs nav-fill" role="tablist">
			<li class="nav-item nav-item-small" role="tab" v-for="trackingStatisticType in trackingStatisticTypes" :key="trackingStatisticType.key" @click="selectedTrackingType = trackingStatisticType">
				<a class="nav-link nav-link-small" :class="{ 'active': trackingStatisticType.key === selectedTrackingType.key  }">{{trackingStatisticType.label}}</a>
			</li>
		</ul>
		<table class="submissions-list-table table table-striped table-tracking-statistic" v-if="selectedTrackingStatistic && selectedTrackingStatistic.length > 0">
			<thead>
				<tr>
					<th width="40%">Name</th>
					<th width="20%">Order</th>
					<th width="20%">Paid</th>
					<th>Paid Ratio</th>
				</tr>
			</thead>
			<tbody>
				<tr v-for="trackingStatistic in selectedTrackingStatistic.slice(0, 5)" :key="trackingStatistic.name">
					<td align="left">{{trackingStatistic.name}}</td>
					<td>{{trackingStatistic.submission_count}}</td>
					<td>{{trackingStatistic.transaction_count}}</td>
					<td>{{trackingStatistic.paid_ratio}}%</td>
				</tr>
			</tbody>
		</table>
		<div v-else class="chart-empty pb-0"><i class="material-icons md-48">error_outline</i> There is no data available</div>
		<a class="chart-see_more" v-if="selectedTrackingStatistic && selectedTrackingStatistic.length > 5" @click="$emit('trackingStatisticSeeMore', selectedTrackingStatistic)">See More</a>
	</div>
</template>

<script>

export const trackingStatisticTypes = [
	{
		key: 'utm_campaign',
		label: 'UTM Campaign',
		description: '',
	},
	{
		key: 'utm_medium',
		label: 'UTM Medium',
		description: '',
	},
	{
		key: 'utm_source',
		label: 'UTM Source',
		description: '',
	},
	{
		key: 'utm_content',
		label: 'UTM Content',
		description: '',
	},
];

const firstTrackingStatisticTypes = Object.assign({}, trackingStatisticTypes[0]);

export default {
	name: 'TrackingStatistic',
	props: [
		'data',
	],
	data() {
		return {
			selectedTrackingType: firstTrackingStatisticTypes,
			trackingStatisticTypes,
			isShowCustomerCities: false,
		};
	},
	computed: {
		// totalConversionsData() {
		// 	return Object.keys(this.data.conversions_data).length;
		// },
		selectedTrackingStatistic() {
			return this.data[this.selectedTrackingType.key];
		},
	},
};
</script>
